import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const getReferences = (lang = '') =>
  post(`/accounting/api/formdata?lang=${lang}`).then(camelizeKeys);
